import { useCallback } from "react";
import BranchForm from "../components/BranchForm";
import branchFormValidator from "../validators/validator";
import { IWizardConfig, WizardMode } from "../../../wizard/types";
import useBranchQueries from "../../../school/hooks/useBranchQueries";
import { useSchoolId } from "../../../school/hooks/useSchoolId";
import { EducationType } from "../../../school/constants/types";
import { getName } from "country-list";
import { useProfile } from "../../../user/hooks/useProfile";

async function parseBranchDataForEdit(data, isLanguageSchool: boolean) {
  return {
    id: data.id,
    schoolId: data.schoolId,
    ...(isLanguageSchool && {
      country: {
        code: data.country,
        name: getName(data.country),
      },
    }),
    state: data.state,
    city: data.city,
    address: data.address,
    zip: data.zip,
  };
}

export function useEditBranchConfig(branchData): IWizardConfig {
  const { fetchUpdate } = useBranchQueries();
  const profile = useProfile();
  const schoolId = useSchoolId();
  const isLanguageSchool = profile.school.type.id === EducationType.Language;

  const parseToBackEndModel = (data, schoolId) => ({
    schoolId,
    country: data.country?.code,
    state: data.state ? data.state.trim() : null,
    city: data.city.trim(),
    address: data.address.trim(),
    zip: data.zip.trim(),
  });

  const editBranch = useCallback(
    async (data, schoolId) => {
      const id = data.id;
      return await fetchUpdate(id, parseToBackEndModel(data, schoolId));
    },
    [fetchUpdate],
  ); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    steps: [
      {
        width: "552px",
        titleConfig: {
          titleText: "Edit branch",
        },
        content: BranchForm,
        validator: branchFormValidator,
      },
    ],
    getInitialData: () =>
      parseBranchDataForEdit({ ...branchData, schoolId }, isLanguageSchool),
    saveCallback: (data) => editBranch(data, schoolId),
    submitButtonText: "Save",
    cancelButtonText: "Close",
    mode: WizardMode.Edit,
  };
}
